import { updatesData } from '@/mocks/home-data';

export default function UpdatesSection() {
  return (
    <section id="updates" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-8 h-8 flex items-center justify-center bg-accent-100 rounded-lg">
            <i className="ri-timer-flash-line text-accent-600 text-base"></i>
          </span>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">最新快讯</h2>
        </div>
        <p className="text-sm text-foreground-600 mb-8 ml-11">7×24 小时实时追踪 · 滚动更新</p>

        <div className="relative pl-8 border-l-2 border-background-200">
          {updatesData.map((item) => (
            <div key={item.id} className="relative mb-8 last:mb-0 group cursor-pointer">
              <div className="absolute -left-[33px] top-0 w-4 h-4 rounded-full bg-background-100 border-2 border-primary-400 group-hover:bg-primary-400 transition-colors"></div>
              <div className="bg-background-50 rounded-lg p-4 md:p-5 border border-background-200/70 group-hover:border-primary-200 transition-colors">
                <div className="flex items-center gap-3 mb-2 flex-wrap">
                  <span className="text-xs font-bold text-primary-600 whitespace-nowrap">{item.time}</span>
                  <span className="text-[10px] font-medium px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 whitespace-nowrap">
                    {item.tag}
                  </span>
                </div>
                <h3 className="text-sm md:text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors leading-snug">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}